import React, { Component } from 'react';



class cat extends Component {
    // state = {

    // }
    // handleChange = (e) => {
    //     console.log(e);
    // }
    // handleSubmit = (e) => {
    //     console.log(e);
    // }
    render() {



        return (
            <section>

            <section className="container section">

            <h4 className="titleENG center">My Cat</h4>
                <div className="row">
                    <div className="col s12 l6">
                        <img src="../img32/0.jpg" alt="" className="responsive-img materialboxed"/>
                    </div>
                    <div className="col s12 l4 offset-l2">
                        <h4 className="black-text school">Latiao</h4>
                        <div className="YXdetail">
                            <p className="YXdetailP">Name: Latiao</p>
                            <p className="YXdetailP">Gender: Male</p>
                            <p className="YXdetailP">Born: October 12, 2016(age 8 years), Canada</p>
                            <p className="YXdetailP">Weight: 5.7kg</p>
                        </div>
                    </div>
                </div>

                <h4 className="titleENG center">Some Pictures...</h4>    

              <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/27.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/26.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/25.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/24.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/23.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/22.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/21.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/20.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/19.PNG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/1.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/2.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/3.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

        
                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/4.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/5.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/6.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

        
        
                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/7.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/8.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/9.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

        
        
                <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/10.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/11.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/12.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
        </div>
        
        
                        <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/13.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/14.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/15.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>
        
                        <div className="row">
                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/16.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/17.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m4 l4">
                        <div className="card">
                        <div className="card-image">
                            <img src="../img32/18.jpg" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>
        
       
            </section>
           
            </section>
        )
    }
}




export default cat
